import { gql } from '@/__generated__';

export const METRICS_VIEW_CHART_WIDGET_FIELDS_FRAGMENT = gql(`#graphql
  fragment MetricsViewChartWidgetFields on MetricsViewChartWidget {
    id
    type
    title
    gridVariant
    series {
      station {
        id
      }
      name
      type
      color
      dataType
      unit
      smooth
      symbol
      symbolSize
      step
      gridIndex
      attributes
    }
  }
`);

export const METRICS_VIEW_TABLE_WIDGET_FIELDS_FRAGMENT = gql(`#graphql
  fragment MetricsViewTableWidgetFields on MetricsViewTableWidget {
    id
    type
    title
    columns {
      dataType
      unit
    }
    station {
      id
    }
    pagination
    limit
    compact
  }
`);

export const METRICS_VIEW_DATA_WIDGET_FIELDS_FRAGMENT = gql(`#graphql
  fragment MetricsViewDataWidgetFields on MetricsViewDataWidget {
    id
    dataType
    unit
    style
    type
    title
    attributes
    station {
      id
    }
  }
`);

export const METRICS_VIEW_BUTTON_WIDGET_FIELDS_FRAGMENT = gql(`#graphql
  fragment MetricsViewButtonWidgetFields on MetricsViewButtonWidget {
    id
    type
    attributes
    tooltip
  }
`);

export const METRICS_VIEW_TEXT_WIDGET_FIELDS_FRAGMENT = gql(`#graphql
  fragment MetricsViewTextWidgetFields on MetricsViewTextWidget {
    id
    type
    attributes
  }
`);

export const METRICS_VIEW_GENERIC_WIDGET_FIELDS_FRAGMENT = gql(`#graphql
  fragment MetricsViewGenericWidgetFields on MetricsViewGenericWidget {
    id
    type
    attributes
  }
`);
